exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert-bar-container{bottom:0;left:0;position:fixed;z-index:4}.cap-it-ui-alert-bar{z-index:4}.cap-it-ui-alert-bar .alert-bar-base .alert-bar-base-header{font-size:1.4rem;line-height:2.2rem}.cap-it-ui-alert-bar .alert-bar-base button.dismiss-btn{box-shadow:none;height:31px;margin-right:20px;width:31px}.cap-it-ui-alert-bar .alert-bar-base .dismiss-btn{padding:0}.cap-it-ui-alert-bar .alert-bar-base .alert-bar-base-body{padding-bottom:20px}.cap-it-ui-alert-bar div.notification-area-container{max-height:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/alert-bar-container/alert-bar-container.scss
// module id = 5229
// module chunks = 0